export default "__VITE_ASSET__Bq_gg0z4__"